import { getUrlParamsMapV2 } from '../../../common/utils/browserUtils';
import { getRoomFromParams } from '../../../common/utils/formattingUtils';
import {
  SET_FROM_CITY,
  SET_TO_CITY,
  SET_TRAVEL_DATE,
  SET_DEFAULT_SEARCH,
  SET_SEARCH_TEXT,
  SET_FROM_CITIES_LIST,
  UPDATE_DESTINATION_META,
} from '../actions/searchActions';

const defaultRoom = getUrlParamsMapV2()?.rooms;

export const searchInitialState = {
  default: {
    fromCity: '',
    toCity: '',
    travelDate: '',
    roomGuest: defaultRoom ? getRoomFromParams(defaultRoom) : null,
    searchText: '',
    campaign: '',
    packageIds: [],
    fromCityCode: '',
    toCityCode: '',
    destinationCities: [],
    fromCityType: '',
  },
  applied: {
    fromCity: '',
    toCity: '',
    travelDate: '',
  },
  list: {
    fromCities: [],
    toCities: [],
  },
};

const searchReducer = (state = searchInitialState, action) => {
  switch (action.type) {
    case SET_TO_CITY:
      return {
        ...state,
        default: {
          ...state.default,
          toCity: action.payload.destCity,
          destValue: action.payload.destValue,
        },
      };
    case SET_FROM_CITY:
      return {
        ...state,
        default: {
          ...state.default,
          fromCity: action.payload.name,
          fromCityCode: action?.payload?.locusId,
        },
      };
    case SET_TRAVEL_DATE:
      return {
        ...state,
        default: {
          ...state.default,
          travelDate: action.payload,
        },
      };
    case SET_DEFAULT_SEARCH:
      return {
        ...state,
        default: {
          ...state.default,
          ...action.payload,
        },
      };
    case SET_FROM_CITIES_LIST: {
      return {
        ...state,
        list: {
          ...state.list,
          fromCities: action.payload.listOfDepartureCity,
        },
      };
    }
    case SET_SEARCH_TEXT:
      return {
        ...state,
        searchText: action.payload,
      };
    case UPDATE_DESTINATION_META:
      return {
        ...state,
        default: {
          ...state.default,
          ...action.payload,
        },
      };
    default:
      break;
  }
  return state;
};

export default searchReducer;
